import { Routes } from '@angular/router';
import { AppInitializerErrorGuard, AppInitializerNoErrorGuard, AuthGuard, UserOnboardingStatusGuard } from '@shared/core';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/main',
        pathMatch: 'full',
    },
    {
        path: '',
        canActivate: [AppInitializerErrorGuard],
        loadChildren: () => import('@shared/public-feature').then(m => m.routes),
    },
    {
        path: 'onboarding',
        canActivate: [AuthGuard, AppInitializerErrorGuard],
        loadChildren: () => import('@mcl/onboarding-feature').then(m => m.routes),
    },
    {
        path: 'main',
        canActivate: [AuthGuard, AppInitializerErrorGuard, UserOnboardingStatusGuard],
        loadChildren: () => import('@mcl/main-feature').then(m => m.routes),
    },
    {
        path: 'error',
        canActivate: [AppInitializerNoErrorGuard],
        loadChildren: () => import('@shared/error-feature').then(m => m.routes),
    },
    { path: '**', redirectTo: 'main' },
];
